'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

var _reactI18next = require('react-i18next');

var _dateTimeHelper = require('../../../../helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AvailArrival(props) {
  var components = props.components,
      time = props.time,
      t = props.t;

  var styleArriveValueLabel = (0, _emailStyleTools.textStyles)(components, 'ArriveValueLabel');
  var airport = props.airport,
      city = props.city,
      terminal = props.terminal;

  airport = airport || 'Airport Name';
  city = city || 'City Name';
  terminal = terminal || t('common.na');

  var timeFormatted = _dateTimeHelper2.default.getDate(time) + ' ' + t('car.at') + ' ' + _dateTimeHelper2.default.getTime(time);

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'AvailSegments' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: styleArriveValueLabel },
            airport,
            ', ',
            city
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: styleArriveValueLabel },
            timeFormatted
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: styleArriveValueLabel },
            t('air.ter'),
            ' ',
            terminal
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(AvailArrival));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/AvailArrival.jsx
// module id = 1468
// module chunks = 0